/* eslint-disable jsx-a11y/label-has-for */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Input } from 'web-ui-components/lib/atoms/forms';
import withValidation from '../../../../containers/withValidation';
import {
	fixAmount,
	isAmountWithinLimit,
	sanitizeDecimalOccurrences,
	stripCurrencysIllegalCharacters,
} from '../../../../helpers/fieldHelpers';
import styles from './Amount.styles';

class Amount extends Component {
	constructor(props) {
		super(props);
		this.state = { isActive: false, amount: this.props.amount };
		this.handleOnFocus = this.handleOnFocus.bind(this);
		this.handleOnBlur = this.handleOnBlur.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.amount !== nextProps.amount) this.setState({ amount: nextProps.amount });
	}

	handleOnFocus(event) {
		this.setState({ isActive: true });
		this.props.onFocus(event);
	}

	handleOnBlur(event) {
		const amount = fixAmount(event.target.value);

		this.setState({ isActive: false, amount });
		if (this.props.onBlur) {
			this.props.onBlur(amount);
		}
	}

	handleChange(event) {
		const amount = stripCurrencysIllegalCharacters(event.target.value);
		const sanitizedAmount = sanitizeDecimalOccurrences(amount);

		const { maxAmountForPaymentType } = this.props;
		if (isAmountWithinLimit(sanitizedAmount, maxAmountForPaymentType)) {
			this.setState({ amount: sanitizedAmount });
		}
	}

	render() {
		const {
			id,
			amtLabel,
			isValid,
			showValidation,
			isMaxLimitExceeded,
			maxLimitExceededMessage,
			description,
			showMaxLimitError,
			disable,
			biocatchIdentifier,
		} = this.props;

		const errorMsgVisible = (!isValid && showValidation) || (showMaxLimitError && isMaxLimitExceeded);

		const inputWrapClassName = classNames('c-o-list-payment__input-wrap', {
			'c-o-list-payment__input-wrap--has-error': errorMsgVisible,
		});

		const errorMsgClassName = classNames('c-o-list-payment__error', {
			'c-o-list-payment__error--is-visible': errorMsgVisible,
		});

		const decriptionClassName = classNames('c-o-list-payment__labelled-by', {
			'c-o-list-payment__labelled-by--is-visible': !errorMsgVisible && this.state.isActive && description,
		});

		return (
			<div className="c-o-list-payment__row-cell c-o-list-payment__row-cell--value" data-title={amtLabel}>
				<div className="c-o-list-payment__container">
					<label className="c-o-list-payment__row-label" htmlFor={`field-amount-${id}`}>
						{amtLabel}
					</label>
					<div className={inputWrapClassName}>
						<div className="c-o-list-payment__input-with-fix">
							<div className="c-a-input-text-prompt c-a-input-text-prompt--prefix">
								<div className="c-a-input-text-prompt__title">&pound;</div>
							</div>
							<Input
								type="text"
								className={classNames(styles.amountWrapperStyle, 'c-a-input c-a-input--number has-prefix')}
								id={`field-amount-${id}`}
								data-bb={biocatchIdentifier}
								required=""
								aria-required="true"
								aria-invalid="true"
								value={this.state.amount}
								onChange={this.handleChange}
								onBlur={this.handleOnBlur}
								onFocus={this.handleOnFocus}
								disabled={disable}
								data-test-id={'field-amount'}
								aria-label="payment amount"
							/>
						</div>
					</div>
					{description && <span className={decriptionClassName} dangerouslySetInnerHTML={{ __html: description }} />}
					<span className={errorMsgClassName}>
						{isMaxLimitExceeded ? maxLimitExceededMessage : 'Enter the amount you want to move'}
					</span>
				</div>
			</div>
		);
	}
}

Amount.propTypes = {
	id: PropTypes.string.isRequired,
	amount: PropTypes.string,
	amtLabel: PropTypes.string,
	isValid: PropTypes.bool,
	showValidation: PropTypes.bool,
	onFocus: PropTypes.func.isRequired,
	onBlur: PropTypes.func.isRequired,
	isMaxLimitExceeded: PropTypes.bool,
	maxLimitExceededMessage: PropTypes.string,
	description: PropTypes.string,
	showMaxLimitError: PropTypes.bool,
	disable: PropTypes.bool,
	maxAmountForPaymentType: PropTypes.number,
};

export { Amount };
export default withValidation({ validations: ['required', 'amount'], key: 'amount' })(Amount);
